import { intToStr } from './int-string';

export const unixTimeToDayAndTimeStr = (timestamp: number) => {
  const date = new Date(timestamp);

  const hours = date.getHours();
  const minutes = date.getMinutes();

  const ampm = hours >= 12 ? 'PM' : 'AM';

  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes < 10 ? `0${minutes.toString()}` : minutes;

  const formattedDay = date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return `${formattedHours.toString()}:${formattedMinutes.toString()} ${ampm} ${formattedDay}`;
};

export const unixTimeToYMDHMS = (timestamp: number) => {
  const date = new Date(timestamp);

  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    hours: date.getHours(),
    minutes: date.getMinutes(),
    seconds: date.getSeconds(),
  };
};

export const unixTimeToYMDDashedStr = (timestamp: number) => {
  const { year, month, day } = unixTimeToYMDHMS(timestamp);

  return `${intToStr(year, 4)}-${intToStr(month, 2)}-${intToStr(day, 2)}`;
};

export const unixTimeToHMSString = (timestamp: number) => {
  const { hours, minutes, seconds } = unixTimeToYMDHMS(timestamp);

  return `${intToStr(hours, 2)}:${intToStr(minutes, 2)}:${intToStr(seconds, 2)}`;
};

export const unixTimeToAgo = (timestamp: number) => {
  const { year, month, day } = unixTimeToYMDHMS(timestamp);

  const {
    year: nowYear,
    month: nowMonth,
    day: nowDay,
  } = unixTimeToYMDHMS(Date.now());

  if (year === nowYear && month === nowMonth && day === nowDay) return 'Today';
  if (year === nowYear && month === nowMonth && day === nowDay - 1)
    return 'Yesterday';
  if (year === nowYear && month === nowMonth)
    return `${(nowDay - day).toString()} days ago`;

  if (year === nowYear && month === nowMonth - 1) return 'Last month';
  if (year === nowYear) return `${(nowMonth - month).toString()} months ago`;

  if (year === nowYear - 1) return 'Last year';
  return `${(nowYear - year).toString()} years ago`;
};

export const unixTimeToHourAndMinuteStr = (timestamp: number) => {
  const { hours, minutes } = unixTimeToYMDHMS(timestamp);
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;

  return `${intToStr(displayHours, 2)}:${intToStr(minutes, 2)} ${ampm}`;
};
